import { useEffect, useState } from "react";
import { tokenStorage } from "../../utils/tokenStorage";
import { Button } from "../ui";

export function CookieDialog() {
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    const consent = tokenStorage.getCookieConsent();
    if (consent === null) {
      setShowDialog(true);
    }
  }, []);

  const handleAccept = () => {
    tokenStorage.setCookieConsent(true);
    setShowDialog(false);
  };

  const handleDecline = () => {
    tokenStorage.setCookieConsent(false);
    setShowDialog(false);
  };

  if (!showDialog) {
    return null;
  }

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-dialog-title"
      aria-describedby="cookie-dialog-desc"
      className="fixed bottom-0 left-0 right-0 z-50 w-full border-t border-border bg-background shadow-lg"
    >
      <div className="container mx-auto px-4 py-4 md:py-6">
        <div className="space-y-4">
          <div className="space-y-2">
            <h3 id="cookie-dialog-title" className="text-lg font-bold text-foreground">Cookies Notice</h3>
            <p id="cookie-dialog-desc" className="text-sm text-muted-foreground">
              We use cookies to improve your browsing experience, provide personalized content, and analyze our website
              traffic. Some cookies are essential for the site to function properly, while others help us understand how
              you use our site so we can improve it. By clicking &quot;Accept&quot;, you agree to the use of all
              cookies. You can also choose to Decline. Read our full{" "}
              <a
                href="/cookies-policy"
                className="text-primary hover:underline"
              >
                Cookies Policy
              </a>{" "}
              to learn more.
            </p>
          </div>
          <div className="flex gap-3">
            <Button
              onClick={handleDecline}
              variant="outline"
              className="border-primary bg-card text-primary hover:bg-accent"
            >
              Decline
            </Button>
            <Button
              onClick={handleAccept}
              className="bg-primary text-primary-foreground hover:bg-primary/90"
              autoFocus
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
